import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AcceptInvite from "@/pages/AcceptInvite";
import Billing from "@/pages/Billing";
import Dashboard from "@/pages/Dashboard";
import CallHistory from "@/pages/CallHistory";
import WhatsApp from "@/pages/WhatsApp";
import Social from "@/pages/Social";
import PublicLandingPage from "@/pages/PublicLandingPage";
import Activity from "@/pages/Activity";
import Support from "@/pages/Support";
import Settings from "@/pages/Settings";
import Reports from "@/pages/Reports";
import Campaigns from "@/pages/Campaigns";
import CampaignDetail from "@/pages/CampaignDetail";
import CampaignRun from "@/pages/CampaignRun";
import AgentCampaigns from "@/pages/AgentCampaigns";
import SalesforceSoftphone from "@/pages/SalesforceSoftphone";
import SalesforceBridge from "@/pages/SalesforceBridge";
import SalesforceOAuthCallback from "@/pages/SalesforceOAuthCallback";
import PlatformDashboard from "@/pages/PlatformDashboard";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import DataDeletion from "@/pages/DataDeletion";

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Toaster
                        position="top-center"
                        richColors
                        closeButton
                        expand
                        toastOptions={{
                            style: {
                                borderRadius: "14px",
                                padding: "14px 16px",
                                fontSize: "14px",
                                boxShadow: "0 12px 34px -12px rgba(0,0,0,0.28)",
                            },
                            className: "font-medium",
                            duration: 4500,
                        }}
                    />
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/accept-invite" element={<AcceptInvite />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="/terms-of-service" element={<TermsOfService />} />
                        <Route path="/data-deletion" element={<DataDeletion />} />
                        <Route path="/p/:slug" element={<PublicLandingPage />} />
                        <Route path="/salesforce/softphone" element={<SalesforceSoftphone />} />
                        <Route path="/salesforce/bridge" element={<SalesforceBridge />} />
                        <Route path="/salesforce/oauth/callback" element={<SalesforceOAuthCallback />} />
                        <Route
                            path="/platform"
                            element={
                                <ProtectedRoute roles={["super_admin"]}>
                                    <PlatformDashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/"
                            element={
                                <ProtectedRoute>
                                    <Dashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/calls"
                            element={
                                <ProtectedRoute product="calling">
                                    <CallHistory />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/reports"
                            element={
                                <ProtectedRoute roles={["admin", "supervisor"]} feature="reports" product="calling">
                                    <Reports />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/campaigns"
                            element={
                                <ProtectedRoute roles={["admin", "supervisor"]} feature="campaigns" product="calling">
                                    <Campaigns />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/campaigns/:id"
                            element={
                                <ProtectedRoute roles={["admin", "supervisor"]} feature="campaigns" product="calling">
                                    <CampaignDetail />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/campaigns/:id/run"
                            element={
                                <ProtectedRoute feature="campaigns" product="calling">
                                    <CampaignRun />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/my-campaigns"
                            element={
                                <ProtectedRoute feature="campaigns" product="calling">
                                    <AgentCampaigns />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/whatsapp"
                            element={
                                <ProtectedRoute feature="whatsapp" product="whatsapp">
                                    <WhatsApp />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/social"
                            element={
                                <ProtectedRoute feature="social" product="social">
                                    <Social />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/lead-capture"
                            element={<Navigate to="/social?tab=leadcapture" replace />}
                        />
                        <Route
                            path="/ads"
                            element={<Navigate to="/social?tab=ads-campaigns" replace />}
                        />
                        <Route
                            path="/activity"
                            element={
                                <ProtectedRoute>
                                    <Activity />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/support"
                            element={
                                <ProtectedRoute feature="support_tickets" product="calling">
                                    <Support />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/settings"
                            element={
                                <ProtectedRoute adminOnly>
                                    <Settings />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/billing"
                            element={
                                <ProtectedRoute adminOnly>
                                    <Billing />
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}
